export default __webpack_public_path__ + "static/media/clarity_bell-solid-badged.af9bcc71.svg";